import { render } from "./TaTrainingVideos.vue?vue&type=template&id=fad51aa4&scoped=true"
import script from "./TaTrainingVideos.vue?vue&type=script&lang=js"
export * from "./TaTrainingVideos.vue?vue&type=script&lang=js"

import "./TaTrainingVideos.vue?vue&type=style&index=0&id=fad51aa4&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad51aa4"]])

export default __exports__